import React from 'react';
import { BaasicDropzone, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function ProductImportTemplate({
	productListViewStore: {
		productImportForm,
		displaySellerDropdown,
		sellerOptions,
		onSelectChange,
		onFilesDrop,
		downloadExcelTemplate,
		isVirtualSkus = false,
	},
	t,
}) {
	const modalTitle = t(isVirtualSkus ? 'PRODUCTVIEW.IMPORTVIRTUALSKUS' : 'PRODUCTVIEW.IMPORTPRODUCTS');
	return (
		<section className="ReactModal__form">
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t(modalTitle)}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="row row--form">
					{displaySellerDropdown && (
						<div className="col col-sml-12 col-med-6 spc--bottom--sml">
							<BaasicSelect
								placeholder={t('PLACEHOLDER.SELLER')}
								field={productImportForm.$('seller')}
								options={sellerOptions}
								clearable={true}
								value={productImportForm.$('seller').value}
								onChange={value => onSelectChange(value, productImportForm.$('seller'))}
							/>
						</div>
					)}
					<div className="col col-sml-12 col-med-6 spc--bottom--sml">
						<button
							type="button"
							className="btn btn--med btn--primary btn--primary--negative w--100"
							onClick={downloadExcelTemplate}
						>
							<i className="fa fa-download spc--right--sml"></i>
							{t('PRODUCTVIEW.DOWNLOADEXCELTEMPLATE')}
						</button>
					</div>
					<div className="col col-sml-12">
						<BaasicDropzone acceptFiles={'.xls, .xlsx, .csv, text/plain'} onFilesDrop={onFilesDrop} />
					</div>
				</div>
			</div>
		</section>
	);
}

export default defaultTemplate(ProductImportTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/ProductImportTemplate.jsx